<template>
    <div class="firstpage" @click="close()">
      <!-- 弹窗 -->
      <div class="popup" id="popup">
          <img src="https://www.kia.cn/assets/~/media/images/dyk/index/footer/copy-success.png">
          <div style="margin-top: 5px;">复制成功</div>
      </div>
      <!-- mob 分享弹窗 -->
      <div class="popup-mob-share" id="popup-mob-share">
          <a create-qr-mob>
          <img @click="shareWechat" class="popup-mob-share-img weixin-img" src="https://www.kia.cn/assets/~/media/images/dyk/index/footer/mob-share-wechat.png">
          <div id="qr-popup-mob-share" class="qr-popup-mob-share">
              <!-- <div class="qr-code-wx" id="qrcodeCanvas"></div> -->
              <img class="qr-code-wx" src="" alt="" id="qrcodeCanvas">
              <!-- <img style="position: absolute;top:55px;width: 40px;height:14px;background-color:#ffffff;margin: 0;" src="https://www.kia.cn/assets/~/media/images/dyk/index/footer/logo-share-qr.jpg"> -->
              <!-- <img style="height:40px;padding-top:10px" src="https://www.kia.cn/assets/~/media/images/dyk/index/footer/qr-text.png"> -->
          </div>
          </a>
          <a weibo>
          <img @click="shareToWeibo" class="popup-mob-share-img" src="https://www.kia.cn/assets/~/media/images/dyk/index/footer/mob-share-weibo.png">
          </a>
          <a copy>
          <img @click="shareCopy" class="popup-mob-share-img" src="https://www.kia.cn/assets/~/media/images/dyk/index/footer/mob-share-copy.png">
          </a>
          <div id='popup-mob-close' class="my-button" @click="closePopup" ></div>
      </div>
      <!-- 新增 分享 start -->
      <div class="btn-share-mob btn-share-mob" @click="sharePopup"></div>
      <!-- 新增 分享 end -->

    </div>
  </template>
  
  <script>
  import { isPortraitFun} from "@/utils/utils.js";

  import QRCode from 'qrcodejs2'
  import mShare from "@/utils/mShare"

  export default {

    data() {
      return {
        isPortrait: isPortraitFun(),
        minip: false,

      };
    },
    computed: {
    },
    mounted: function () {
      //mob生成二维码
      // document.getElementById('qrcodeCanvas').src = `https://kiacarservice-uat.kia.cn/kia-carservice-api/QRCode/getQRcode?url=${window.location.href}` 
      if (window.location.href.includes("https://uat.kia.cn")) {
          //生成二维码
          
          document.getElementById('qrcodeCanvas').src = `https://kiacarservice-uat.kia.cn/kia-carservice-api/QRCode/getQRcode?url=${window.location.href}` 
      } else {
          
          document.getElementById('qrcodeCanvas').src = `https://kiacarservice.kia.cn/kia-carservice-api/QRCode/getQRcode?url=${window.location.href}` 
      }
    },
    unmounted() {
    },
    methods: {
      //新增分享方法 start
      shareToWeibo(){//分享微博
        this.closePopup()
        //url不能带#
        const weiboShareUrl = `http://service.weibo.com/share/share.php?title=${document.title}&pic=https://www.kia.cn/assets/~/media/images/dyk/index/footer/weibo-share-link.jpg&url=${window.location.href}`;
        window.open(weiboShareUrl);
      },
      shareCopy(){//复制
        if(document.execCommand("Copy")){
          try {
            var txtEl = document.createElement('textarea');
            txtEl.value = window.location.href;
            document.body.appendChild(txtEl);
            txtEl.select(); // 选择对象
            document.execCommand("Copy"); // 执行浏览器复制命令
            txtEl.remove();
            
            this.closePopup()
            const popup = document.getElementById('popup');
            setTimeout(function() {
                popup.style.display = 'flex';
                setTimeout(function() {
                    popup.style.display = 'none';
                }, 1000);
            }, 0);
          } catch(err) {
            // 复制失败
            console.log(err);
          }
        }else{
          navigator.clipboard.writeText(window.location.href).then(() => {
            this.closePopup()
            const popup = document.getElementById('popup');
            setTimeout(function() {
                popup.style.display = 'flex';
                setTimeout(function() {
                    popup.style.display = 'none';
                }, 1000);
            }, 0);
          }).catch((err) => {
              console.log(err);
          });
        }
      },
      //关闭弹窗
      closePopup(){
        var isShow = document.getElementById("popup-mob-share");
        isShow.style.display = "none";
        var isShow1 = document.getElementById("qr-popup-mob-share");//关闭二维码
        isShow1.style.display = "none";
      },
      sharePopup(){//弹出分享弹窗
        var isShow = document.getElementById("popup-mob-share");
        if(isShow.style.display !== "flex"){
          isShow.style.display = "flex";
        }else{
          isShow.style.display = "none";
          var isShow1 = document.getElementById("qr-popup-mob-share");//关闭二维码
          isShow1.style.display = "none";
        }
      },
      //微信分享
      shareWechat(){
        var UA = navigator.appVersion;
        var uc = UA.split('UCBrowser/').length > 1 ? 1 : 0;
        var qq = UA.split('MQQBrowser/').length > 1 ? 2 : 0;
        var wx = /micromessenger/i.test(UA);
        if(uc || (qq && !wx)){
          this.closePopup()
          var mshare = new mShare({
            title: document.title,
            url: window.location.href,
            desc: '',
            img: 'https://www.kia.cn/assets/~/media/images/dyk/index/footer/weibo-share-link.jpg'
          });
          setTimeout(function(){
            mshare.init(2);
          },800)
        }else{
          var isShow = document.getElementById("qr-popup-mob-share");
          if(isShow.style.display !== "flex"){
            isShow.style.display = "flex";
          }else{
            isShow.style.display = "none";
          }
        }
      }
      //end
      },
    };
  </script>
  
  <style lang="scss" scoped>
  .firstpage {
    position: relative;
    // height: 100%;
    // padding-bottom: 230px;
    width: 100%;
    overflow-y: auto;
    user-select: none;
    background-color: #000000;
  
    @media(max-width: 768px) {
      img {
        margin-top: -1px;
      }
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  
    object {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  
    .swiper-box {
      width: 100%;
      overflow: hidden;
    }
  
    .my-form-box {
      width: 100%;
      // 
      display: flex;
      align-items: flex-end;
      position: fixed;
      bottom: 0;
      border-radius: 10px 10px 0px 0px;
      z-index: 2;
  
      .form-container {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        background-color: #fff;
        transition: transform 0.5s;
      }
  
      .slide-up {
        transform: translateY(390px);
      }
  
      // padding: 10px 16px 0;
    }
  
    .bgmask {
      background: #00000080;
      position: fixed;
      top: 0;
      height: 100%;
      width: 100%;
      z-index: 1;
    }
  }
  
  .yy-box {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  
    img {
      width: 24px;
      margin-bottom: 20px;
      animation: tbmove 0.7s infinite;
      // height: ;
    }
  
    &-btn {
      width: 80%;
  
      button {
        width: 100%;
        height: 43px;
        border-radius: 24px;
        background-color: #000000;
        color: #fff;
        border: 1px solid #FFFFFF;
        // background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 1));
      }
    }
  }
  
  .right-btn-box{
    display: flex;
    flex-direction: column;
  
    img{
      margin-top: 10px;
      width: 44px;
      height: 44px;
    }
  }
  @keyframes tbmove {
    from {
      margin-bottom: 10px;
    }
  
    to {
      margin-bottom: 20px;
    }
  }

  /* 新增 css start */
.popup { /* 复制成功*/
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 120px;
    height: 120px;
    background-color: #05141F;
    opacity: 0.8;
    border-radius: 10px;
    /* display: flex; */
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 1000000;
    font-size: 16px;
    color: #ffffff;
  }
  .popup img {
    width: 40px;
    height: 40px;
    margin-bottom: 5px;
  }

  /* mob分享弹窗 */
  .popup-mob-share { /* 复制成功*/
    position: fixed;
    left: 50%;
    // top: 50%;
    bottom: calc(-6vh + 40px);
    width: 70%;
    transform: translate(-50%, -50%);
    background-color: #05141F;
    opacity: 0.9;
    border-radius: 10px;
    /* display: flex; */
    display: none;
    justify-content: space-between;
    align-items: center;
    z-index: 15;
    font-size: 16px;
    padding: 40px 30px 30px 30px;
  }
  .popup-mob-share .popup-mob-share-img {
    width: 50px;
    height: 65px;
    margin-bottom: 5px;
  }
  .qr-popup-mob-share{
    width: 120px;
    height: 120px;
    border-radius: 10px;
    background-color: #ffffff;
    display: none;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: -100px;
    right: calc(100% - 115px);
    transition: all .5s;
  }
  .qr-popup-mob-share::after {
    content: "";
    position: absolute;
    bottom: -5px;
    left: 50%; 
    transform: translateX(-50%);
    margin-bottom: -5px; /* 使三角形垂直居中 */
    border-width: 6px;
    border-style: solid;
    border-color: #f9f9f9 transparent transparent transparent; 
}
.qr-popup-mob-share .qr-code-wx {
      width: 91px;
      height: 91px;
      /* margin-bottom: 10px; */
  }

  .my-button {
    background: url('https://www.kia.cn/assets/~/media/images/dyk/index/footer/guanbi.png') no-repeat;
    background-size: cover;
    right:-10px;
    top:-10px;
    width:24px;
    height:24px;
    position:absolute;
  }
  .a-share-wx:hover .qr-code-box-wx {
    display: flex;
  }
  .qr-code-box-wx {
    width: 120px;
    height: 120px;
    border-radius: 10px;
    background-color: #ffffff;
    /* display: flex; */
    display: none;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0px;
    right: 168px;
    transition: all .5s;
  }
  .qr-code-box-wx::after {
    content: "";
    position: absolute;
    top: 40px;
    right: -10px; /* 调整三角形位置 */
    margin-top: -5px; /* 使三角形垂直居中 */
    border-width: 6px;
    border-style: solid;
    border-color: transparent transparent transparent #f9f9f9; /* 通过调整颜色来隐藏或显示三角形 */
}

  .qr-code-box-wx .qr-code-wx {
      width: 91px;
      height: 91px;
      /* margin-bottom: 10px; */
  }

  .qr-code-box-wx .text-wx {
      font-size: 12px;
      color: #05141F;
      line-height: 16px;
      width: 100px;
      text-align: center;
  }
 @media (min-width: 768px) {
  .btn-share-pc {
      display: block;
  }
  .btn-share-mob {
      display: none;
  }
  
}
@media (max-width: 768px) {
  .btn-share-mob{
    background: url('https://www.kia.cn/assets/~/media/images/dyk/index/footer/share-threepoint.png') no-repeat;
    background-size: 100%;
    // width: calc(80 / 750 * 100vw);
    // height: calc(80 / 750 * 100vw);
    position: fixed;
    bottom: calc(6vh + 40px);
    right: 8px;
    width: 35px;
    height: 35px;
    cursor: pointer;
    overflow: visible;
    z-index: 1000000009;
  }
  .btn-share-mob:hover {
    overflow: visible;
  }
  .btn-share-pc {
      display: none;
  }

  .btn-share-mob {
      display: block;
  }
  .dropdown-content-mob {
    border-radius: 10px;
    min-width: 140px;
    background-color: #ffffff;
    /* display: flex; */
    display: none;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: -80px;
    right: 43px;
    transition: all .5s;
    padding: 15px 0;
  }
  .dropdown-content-mob::after {
    content: "";
    position: absolute;
    top: 50%;
    right: -10px; /* 调整三角形位置 */
    margin-top: -5px; /* 使三角形垂直居中 */
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent transparent #f9f9f9; /* 通过调整颜色来隐藏或显示三角形 */
}
  .dropdown-item-mob {
    min-width: 160px;
    font-size: 16px;
    font-weight: 400;
      display: flex;
      align-items: center;
      padding: 15px 25px 15px 25px;
  }
  .dropdown-item-text-mob {
    padding-left: 10px;
  }
}
  /* 新增 css end */
  </style>
  